/** Minimal distance between a floating element (menu, popup) and the edges of the viewport, in pixels */
export const VIEWPORT_PADDING = 8
